<template>
  <div class="backtest-macd-optimize-view">
    <BacktestMACDOptimize />
  </div>
</template>

<script>
import BacktestMACDOptimize from '@/components/quant-trading/BacktestMACDOptimize.vue'

export default {
  name: 'BacktestMACDOptimizeView',
  components: { BacktestMACDOptimize }
}
</script>

<style scoped>
.backtest-macd-optimize-view {
  width: 100%;
  height: 100%;
}
</style>
